export { default, getStaticProps } from 'containers/AboutPage/AboutPage';
